import {
  Container,
  Checkbox,
  FormControlLabel,
  Typography,
  Box,
  FormLabel,
  Radio,
  RadioGroup,
  FormControl,
  FormGroup,
} from "@mui/material";
import React, { useMemo } from "react";

const packagePrices = {
    "1": 102300,
    "2": 159500,
    "3": 211200,
    "4横列": 267300,
    "4背抜き": 293700,
};

const Comp8PDF = ({
    formData,
    checked,
    selectedPlans
}) => {

    const planOptions = [
        { label: "1小間ベースプラン 102,300円", value: "1" },
        { label: "2小間ベースプラン 159,500円", value: "2" },
        { label: "3小間ベースプラン 211,200円", value: "3" },
        { label: "4小間横列ベースプラン 267,300円", value: "4横列" },
        { label: "4小間背抜きベースプラン 293,700円", value: "4背抜き" },
    ];
    const OUTLET_POSITIONS = ["A", "B", "C", "D"];

    const totalPrice = useMemo(() => {
    return selectedPlans.reduce((sum, plan) => {
        const price = packagePrices[plan.value] || 0;
        return sum + price * plan.quantity;
    }, 0);
    }, [selectedPlans]);

    const isNoApply =
        formData?.exhibitor_status === "申請しない" &&
        formData?.host_status === "申請しない" &&
        formData?.corporate_status === "申請しない";

  return (
    <Container sx={{ mt: 5 ,borderRadius: 2, position: 'relative', py: 4, width:'140%' }}>
    <Box>
        <Typography variant="h6">メッセナゴヤ出展者　マイページ情報</Typography>
        {formData ? (
        <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
            <Typography variant="body1">小間番号: {formData?.booth_number}</Typography>
            <Typography variant="body1">出展者名: {formData?.company_name}</Typography>
            <Typography variant="body1">部署: {formData?.department}</Typography>
            <Typography variant="body1">担当者名: {formData?.user_name}</Typography>
            <Typography variant="body1">郵便番号: {formData?.zip_code}</Typography>
            <Typography variant="body1">住所: {formData?.address}</Typography>
            <Typography variant="body1">電話番号: {formData?.phone_number}</Typography>
            <Typography variant="body1">メールアドレス: {formData?.email}</Typography>
        </Box>
        ) : (
        <Typography variant="body2">読み込み中...</Typography>
        )}
    </Box>
    <Box>
        <Typography variant="h6">パッケージ装飾・出展者専用倉庫・名刺交換用iPhone・パッケージプラン申込</Typography>
        <FormControlLabel
            control={<Checkbox checked={isNoApply} readOnly />}
            label="申請しない"
        />
        {!isNoApply && (
        <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
            <Typography variant="h6" gutterBottom>
            担当者情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_ex}>
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>氏名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_8_name}</Box>
                <Box>部署</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_8_department}</Box>
                <Box>会社電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_8_phone}</Box>
                <Box>携帯電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.user_8_tel}</Box>
            </Box>

            <Typography variant="h6" gutterBottom>
            請求先情報
            </Typography>
            <FormControl component="fieldset">
            <FormLabel component="legend">出展申込時の担当者と</FormLabel>
            <RadioGroup row value={formData?.same_in} >
                <FormControlLabel value="same" control={<Radio />} label="同じ" />
                <FormControlLabel value="different" control={<Radio />} label="異なる" />
            </RadioGroup>
            </FormControl>
            <Box
                sx={{
                display: "grid",
                gridTemplateColumns: "120px 1fr 120px 1fr",
                gap: "4px 12px",
                fontSize: "12px",
                lineHeight: 1.4,
                whiteSpace: "nowrap",
                }}
            >
                <Box>請求先会社名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_company_name}</Box>
                <Box>請求担当者名</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_user_name}</Box>
                <Box>請求先メールアドレス</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_email}</Box>
                <Box>郵便番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_zip}</Box>
                <Box>請求先住所</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_address}</Box>
                <Box>電話番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_tel}</Box>
                <Box>FAX番号</Box><Box sx={{
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    whiteSpace: "nowrap",
                    borderRight: "1px solid #999",
                }}>{formData?.invoice_fax}</Box>
            </Box>
            <FormGroup row>
                <FormControlLabel
                control={<Checkbox name="pack" checked={checked.pack} />}
                label="パッケージ装飾を希望する"
                />
                <FormControlLabel
                control={<Checkbox name="storage" checked={checked.storage} />}
                label="出展者専用倉庫を希望する"
                />
                <FormControlLabel
                control={<Checkbox name="iphone" checked={checked.iphone} />}
                label="名刺交換用iPhoneを希望する"
                />
            </FormGroup>

            {checked.pack && (
            <>
            <Typography variant="h6" gutterBottom>
                パッケージ装飾
            </Typography>
            <Box>
                <FormGroup>
                    {planOptions.map((option) => {
                    const isSelected = selectedPlans.some(p => p.value === option.value);
                    return (
                        <FormControlLabel
                        key={option.value}
                        control={
                            <Checkbox
                            checked={isSelected}
                            />
                        }
                        label={option.label}
                        />
                    );
                    })}
                </FormGroup>

                <Box>
                    {/* 選ばれたプランの数量入力欄 */}
                    {selectedPlans.map((plan, idx) => (
                    <Box key={plan.value}>
                        <Typography>{plan.label}の数量 ： {plan.quantity}</Typography>
                    </Box>
                    ))}
                </Box>

                <Box mt={3}>
                    <Typography variant="h6">合計金額: {totalPrice?.toLocaleString()} 円</Typography>
                </Box>

                <FormControl component="fieldset" margin="normal">
                <FormLabel>社名板</FormLabel>
                <RadioGroup
                    name="plate_select"
                    value={formData?.plate_select ? "true" : "false"}
                    row
                >
                    <FormControlLabel value="true" control={<Radio />} label="希望する" />
                    <FormControlLabel value="false" control={<Radio />} label="希望しない" />
                </RadioGroup>
                </FormControl>
                {formData?.plate_select && (
                  <Typography>{formData?.plate_info}</Typography>
                )}
                <Typography>カーペット色 ： {formData?.carpet_color}</Typography>

                {/* コンセント希望位置 */}
                <Typography variant="subtitle1" sx={{ mt: 2 }}>
                    コンセント希望位置（クリックで選択）
                </Typography>
                <Box
                    sx={{
                    width: 150,
                    height: 150,
                    border: "2px solid #ccc",
                    position: "relative",
                    marginBottom: 1,
                    }}
                >
                    {OUTLET_POSITIONS.map((pos, index) => {
                    const positionStyle = [
                        { top: 0, left: 0 },
                        { top: 0, right: 0 },
                        { bottom: 0, left: 0 },
                        { bottom: 0, right: 0 },
                    ][index];

                    return (
                        <Box
                        key={pos}
                        sx={{
                            width: 70,
                            height: 70,
                            borderRadius: "50%",
                            backgroundColor:
                            formData?.outlet === pos ? "#1976d2" : "#e0e0e0",
                            color: formData?.outlet === pos ? "#fff" : "#000",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            position: "absolute",
                            cursor: "pointer",
                            ...positionStyle,
                        }}
                        >
                        {pos}
                        </Box>
                    );
                    })}
                    <Typography
                    variant="caption"
                    sx={{
                        position: "absolute",
                        bottom: -20,
                        left: "50%",
                        transform: "translateX(-50%)",
                    }}
                    >
                    正面
                    </Typography>
                </Box>

                {/* 追加電気工事 */}
                {/* <FormControl component="fieldset" margin="normal">
                    <FormLabel>追加電気工事</FormLabel>
                    <RadioGroup
                    name="elec_select"
                    value={formData?.elec_select ? "true" : "false"}
                    row
                    >
                    <FormControlLabel value="true" control={<Radio />} label="希望する" />
                    <FormControlLabel value="false" control={<Radio />} label="希望しない" />
                    </RadioGroup>
                    {formData?.elec_select && (
                    <Typography>追加分（kW） ： {formData?.elec_detail}</Typography>
                    )}
                </FormControl> */}
                <Box>
                    <FormControl component="fieldset" margin="normal">
                    <FormLabel>追加プラン</FormLabel>
                    <RadioGroup
                    name="add_select"
                    value={formData?.add_select ? "true" : "false"}
                    row
                    >
                    <FormControlLabel value="true" control={<Radio />} label="希望する" />
                    <FormControlLabel value="false" control={<Radio />} label="希望しない" />
                    </RadioGroup>
                    {formData?.add_select && (
                    <>
                    <Box display="flex" gap={2} flexWrap="wrap">
                        {["A", "B", "C", "D"].map((key) => {
                        const detail = formData?.add_detail ?? "A:0,B:0,C:0,D:0"; // ← ここで安全に初期化
                        const regex = new RegExp(`${key}:(\\d+)`);
                        const match = detail.match(regex);
                        const value = match ? Number(match[1]) : 0;

                        return (
                            <Box key={key} value={value}>
                                <Typography>追加プラン{key} ： {value}</Typography>
                            </Box>
                        );
                        })}
                    </Box>
                    </>
                    )}
                </FormControl>
                </Box>
            </Box>
            </>
            )}

            {checked.storage && (
                <Box>
                <Typography variant="h6" gutterBottom>
                    出展者専用倉庫
                </Typography>
                <Typography>出展者専用倉庫(通常タイプ) ： {formData?.normal_box}</Typography>
                <Typography>出展者専用倉庫(着ぐるみ対応タイプ) ： {formData?.other_box}</Typography>
                {/* <Box sx={{display: 'flex', justifyContent: 'center'}}>
                    <img src="/storage.png" alt="出展者専用倉庫説明図" />
                </Box> */}
                </Box>
            )}

            {checked.iphone && (
                <Box>
                <FormControl component="fieldset" margin="normal">
                    <FormLabel>名刺交換用iPhoneパッケージプラン</FormLabel>
                    <RadioGroup
                    row
                    value={checked.add ? "add" : "default"}
                    >
                    <FormControlLabel value="default" control={<Radio />} label="名刺読み取り用端末（iPhone）3台のみ" />
                    <FormControlLabel value="add" control={<Radio />} label="台数を追加する" />
                    </RadioGroup>
                </FormControl>

                {checked.add && (
                    <Typography>追加iPhone台数 ： {formData?.add_smartphone}</Typography>
                )}
                </Box>
            )}

            <Typography variant="h6">備考欄</Typography>
            <Typography sx={{ whiteSpace: "pre-wrap", wordBreak: "break-word" }}>
                        {formData?.alfa_text}
                        </Typography>
        </Box>
        )}
    </Box>
    </Container>
  );
};

export default Comp8PDF;
